export default "__VITE_ASSET__BSbuvCpT__"